import React from "react";

import {
  HelpRounded,
  MapRounded,
  MenuBookRounded,
  MenuRounded,
  NoTransferRounded,
} from "@mui/icons-material";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import { Constants } from "../../config/constants";
import useFirebase from "../../config/context/firebaseContext";
import useMainState from "../../config/context/mainStateContext";
import useModal from "../../config/context/modalContext";
import { GreyPallet } from "../../config/styles";

import MainText from "../../components/MainText";
import PageHeader from "../../components/PageHeader";

import SelectMain from "../../components/InputMain/SelectMain";
import MainSolidButton from "../../components/MainSolidButton";
import { StyledChip } from "../../components/StyledComponents";

import mapCet from "../../assets/images/bus-cet.png";
import mapDireto from "../../assets/images/bus-direto.png";
import mapInverso from "../../assets/images/bus-inverso.png";
import mapReitoria from "../../assets/images/bus-reitoria.png";

import { BusStopListIdsType } from "../../types/bus";

export default function HelpPage() {
  const navigate = useNavigate();

  const { analyticLog } = useFirebase();
  const { pushAlert, showImage } = useModal();
  const { setShowSideMenuDrawer, openLink } = useMainState();

  const [userLocation, setUserLocation] = React.useState<string | null>(null);
  const [userDestination, setUserDestination] = React.useState<string | null>(null);

  const [availableBus, setAvailableBus] = React.useState<any[]>([]);

  const handleChangeLocation = () => {
    setAvailableBus([]);

    if (userLocation && userDestination) {
      analyticLog("click_help_route", { from: userLocation, to: userDestination });
      setAvailableBus(
        Constants.busStopSchedule.filter((bus) => {
          let from: string | null = null;
          return bus.schedule.some((busId) => {
            if (from) {
              if (Constants.busStopListMap[busId as BusStopListIdsType].name === userDestination)
                return true;
            } else if (
              Constants.busStopListMap[busId as BusStopListIdsType].name === userLocation
            ) {
              from = Constants.busStopListMap[busId as BusStopListIdsType].name;
            }
            return false;
          });
        })
      );
    }
  };

  React.useEffect(() => {
    handleChangeLocation();
  }, [userLocation, userDestination]);

  React.useEffect(() => {
    analyticLog("open_help_page");
  }, []);

  return (
    <Box
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
      pt={"30px"}
      pb={"45px"}
    >
      <Box width={"90%"}>
        <PageHeader
          title="Ajuda"
          leftIcon={<MenuRounded />}
          onLeftAction={() => setShowSideMenuDrawer(true)}
        />

        {/* Qual ônibus */}

        <Box mb={2} display={"flex"} justifyContent={"start"} alignItems={"center"} gap={1}>
          <HelpRounded />
          <MainText size="subtitle" color="black">
            Qual Ônibus Pegar
          </MainText>
        </Box>

        <Box mb={2}>
          <SelectMain
            name="Onde Estou"
            value={userLocation || ""}
            options={Object.keys(Constants.busStopListMap).map((key) => ({
              name: Constants.busStopListMap[key as BusStopListIdsType].name,
              value: Constants.busStopListMap[key as BusStopListIdsType].name,
            }))}
            onChange={setUserLocation}
          />
        </Box>

        <Box mb={2}>
          <SelectMain
            name="Meu Destino"
            value={userDestination || ""}
            options={Object.keys(Constants.busStopListMap).map((key) => ({
              name: Constants.busStopListMap[key as BusStopListIdsType].name,
              value: Constants.busStopListMap[key as BusStopListIdsType].name,
            }))}
            onChange={setUserDestination}
          />
        </Box>

        {userDestination && userLocation ? (
          <Box>
            {availableBus.length ? (
              <MainText color="regular">
                Saindo de <span style={{ color: "black" }}>{userLocation}</span> indo para{" "}
                <span style={{ color: "black" }}>{userDestination}</span> você pode pegar:
              </MainText>
            ) : (
              <Box>
                <Box display={"flex"} justifyContent={"start"} alignItems={"center"} gap={1} mb={2}>
                  <NoTransferRounded />
                  <MainText color="regular">
                    Parece que nenhum ônibus faz a rota de{" "}
                    <span style={{ color: "black" }}>{userLocation}</span> indo para{" "}
                    <span style={{ color: "black" }}>{userDestination}</span>.
                  </MainText>
                </Box>
                <MainText color="regular" size="caption">
                  Talvez olhando o Mapa das Rotas abaixo você consiga achar uma parada próxima.
                </MainText>
              </Box>
            )}

            <Box my={2} display={"flex"} justifyContent={"start"} flexWrap={"wrap"} gap={1}>
              {availableBus.map((item) => (
                <StyledChip
                  chipcolor={item.id}
                  key={item.id}
                  // sx={{ opacity: 0.3 }}
                  label={item.name}
                />
              ))}
            </Box>
          </Box>
        ) : (
          <MainText size="caption" color="regular">
            Escolha a parada de origem e de destino.
          </MainText>
        )}

        {/* Mapa */}

        <Box mt={5} mb={2} display={"flex"} justifyContent={"start"} alignItems={"center"} gap={1}>
          <HelpRounded />
          <MainText size="subtitle" color="black">
            Mapa das Rotas
          </MainText>
        </Box>

        <Box>
          <Box display={"flex"} gap={1}>
            <MainSolidButton
              small
              text="Direto"
              onClick={() => {
                analyticLog("click_help_bus_map", { bus: "dir" });
                showImage(mapDireto);
              }}
            />
            <MainSolidButton
              small
              text="Inverso"
              onClick={() => {
                analyticLog("click_help_bus_map", { bus: "inv" });
                showImage(mapInverso);
              }}
            />
          </Box>

          <Box display={"flex"} gap={1} mt={1} mb={1}>
            <MainSolidButton
              small
              text="Expresso Reitoria"
              onClick={() => {
                analyticLog("click_help_bus_map", { bus: "rei" });
                showImage(mapReitoria);
              }}
            />
            <MainSolidButton
              small
              text="Expresso C&T"
              onClick={() => {
                analyticLog("click_help_bus_map", { bus: "cet" });
                showImage(mapCet);
              }}
            />
          </Box>

          <MainText size="small" color="regular">
            *A seta maior indica de onde ele sai. As menores indicam o sentido.
          </MainText>

          <Box mt={2}>
            <MainSolidButton
              text="Ver no Google Maps"
              icon={<MapRounded />}
              onClick={() => {
                analyticLog("click_help_bus_map", { bus: "maps" });
                openLink(
                  "https://www.google.com/maps/d/u/0/viewer?mid=1suXJNYuMp2OPrc0jXb-61bjnE2c&g_ep=CAESCjExLjExNy4xMDEYACDdYiobLDk0MjA3ODA1LDQ3MDc1OTE1LDQ3MDg0Mzg3QgJCUg%3D%3D&shorturl=1&ll=-5.837955563699055%2C-35.20458525820391&z=15"
                );
              }}
            />
          </Box>
        </Box>

        {/* Etiqueta */}

        <Box mt={5} mb={2} display={"flex"} justifyContent={"start"} alignItems={"center"} gap={1}>
          <HelpRounded />
          <MainText size="subtitle" color="black">
            Etiqueta do Circular
          </MainText>
        </Box>

        <Box mb={1}>
          <MainText size="caption">
            - Só entrar DEPOIS que todo mundo descer:{" "}
            <span style={{ color: GreyPallet.Regular }}>
              Quando for subir no ônibus, deixar a frente da porta livre para que os coleguinhas
              possam descer. SOMENTE DEPOIS DISSO é que você pode entrar.
            </span>
          </MainText>
        </Box>

        <Box mb={1}>
          <MainText size="caption">
            - Gentileza gera gentileza:{" "}
            <span style={{ color: GreyPallet.Regular }}>
              Se você está sentado, se ofereça para levar a mochila de alguma pobre alma mortal que
              não coneguiu ir sentada.
            </span>
          </MainText>
        </Box>

        <Box mb={1}>
          <MainText size="caption">
            - NÃO HÁ lugar marcado:{" "}
            <span style={{ color: GreyPallet.Regular }}>
              Se por um acaso alguém deixou a mochila no banco marcado pro amiguinho que vai subir
              depois, você está autorizado a jogar a mochila no chão e sentar no lugar. Não existe
              lugar marcado no Circular.
            </span>
          </MainText>
        </Box>

        {/* Horarios */}

        <Box mt={5} mb={2} display={"flex"} justifyContent={"start"} alignItems={"center"} gap={1}>
          <HelpRounded />
          <MainText size="subtitle" color="black">
            Horários de Aula
          </MainText>
        </Box>

        <Box>
          <TableContainer>
            <Table size="small" aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">
                    <MainText size="caption">Matutino</MainText>
                  </TableCell>
                  <TableCell align="center">
                    <MainText size="caption">Vespertino</MainText>
                  </TableCell>
                  <TableCell align="center">
                    <MainText size="caption">Noturno</MainText>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                  <TableCell align="center">
                    <MainText size="caption" color="regular">
                      (M1) 07h00 às 07h50
                    </MainText>
                  </TableCell>
                  <TableCell align="center">
                    <MainText size="caption" color="regular">
                      (T1) 13h00 às 13h50
                    </MainText>
                  </TableCell>
                  <TableCell align="center">
                    <MainText size="caption" color="regular">
                      (N1) 18h40 às 19h30
                    </MainText>
                  </TableCell>
                </TableRow>
                <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                  <TableCell align="center">
                    <MainText size="caption" color="regular">
                      (M2) 07h50 às 08h40
                    </MainText>
                  </TableCell>
                  <TableCell align="center">
                    <MainText size="caption" color="regular">
                      (T2) 13h50 às 14h40
                    </MainText>
                  </TableCell>
                  <TableCell align="center">
                    <MainText size="caption" color="regular">
                      (N2) 19h30 às 20h20
                    </MainText>
                  </TableCell>
                </TableRow>
                <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                  <TableCell align="center">
                    <MainText size="caption" color="regular">
                      (M3) 08h50 às 09h40
                    </MainText>
                  </TableCell>
                  <TableCell align="center">
                    <MainText size="caption" color="regular">
                      (T3) 14h50 às 15h40
                    </MainText>
                  </TableCell>
                  <TableCell align="center">
                    <MainText size="caption" color="regular">
                      (N3) 20h30 às 21h20
                    </MainText>
                  </TableCell>
                </TableRow>
                <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                  <TableCell align="center">
                    <MainText size="caption" color="regular">
                      (M4) 09h40 às 10h30
                    </MainText>
                  </TableCell>
                  <TableCell align="center">
                    <MainText size="caption" color="regular">
                      (T4) 15h40 às 16h30
                    </MainText>
                  </TableCell>
                  <TableCell align="center">
                    <MainText size="caption" color="regular">
                      (N4) 21h20 às 22h10
                    </MainText>
                  </TableCell>
                </TableRow>
                <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                  <TableCell align="center">
                    <MainText size="caption" color="regular">
                      (M5) 10h40 às 11h30
                    </MainText>
                  </TableCell>
                  <TableCell align="center">
                    <MainText size="caption" color="regular">
                      (T5) 16h40 às 17h30
                    </MainText>
                  </TableCell>
                  <TableCell align="center"></TableCell>
                </TableRow>
                <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                  <TableCell align="center">
                    <MainText size="caption" color="regular">
                      (M6) 11h30 às 12h20
                    </MainText>
                  </TableCell>
                  <TableCell align="center">
                    <MainText size="caption" color="regular">
                      (T6) 17h30 às 18h20
                    </MainText>
                  </TableCell>
                  <TableCell align="center"></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          {/* Matutino Vespertino Noturno
        (M1) 07h00 às 07h50 (T1) 13h00 às 13h50 (N1) 18h40 às 19h30
        (M2) 07h50 às 08h40 (T2) 13h50 às 14h40 (N2) 19h30 às 20h20
        (M3) 08h50 às 09h40 (T3) 14h50 às 15h40 (N3) 20h30 às 21h20
        (M4) 09h40 às 10h30 (T4) 15h40 às 16h30 (N4) 21h20 às 22h10
        (M5) 10h40 às 11h30 (T5) 16h40 às 17h30
        (M6) 11h30 às 12h20 (T6) 17h30 às 18h20 */}
        </Box>

        <Box my={1}>
          <MainText size="body">- Os códigos dos horários de aula são formados por:</MainText>

          <Box my={1}>
            <MainText size="small" color="regular">
              DIA DA SEMANA (sendo o 2 segunda, 3 pra terça e etc..)
            </MainText>
          </Box>
          <Box mb={1}>
            <MainText size="small" color="regular">
              TURNO (M de manhã, T de tarde e etc..)
            </MainText>
          </Box>
          <Box mb={1}>
            <MainText size="small" color="regular">
              HORÁRIOS (Números de 0 a 6 que você consulta na tabela acima)
            </MainText>
          </Box>
        </Box>

        <Box my={1}>
          <MainText size="caption">
            Dessa forma o horario "24M56" seria lido como "Segunda e Quarta, Manhã, Das 10:40 até às
            12:20"
          </MainText>
        </Box>

        <Box mb={1}>
          <MainText size="small" color="regular">
            Eu particularmente só decorei que o M12 começa de 7 da manha e o T12 começa de 1h da
            tarde e é isso... E olha que eu tô nessa universidade há 6 anos Kkkk
          </MainText>
        </Box>

        {/* Wifi */}

        <Box mt={5} mb={2} display={"flex"} justifyContent={"start"} alignItems={"center"} gap={1}>
          <HelpRounded />
          <MainText size="subtitle" color="black">
            Conectar ao WiFi
          </MainText>
        </Box>

        <Box mb={2}>
          <MainText color="regular">
            Para se conectar na rede da UF (eduroam) você usa o login do SIGAA. Para mais
            informações de como se conectar a todas as redes no Campus veja os manuais da
            Superintendência de Tecnologia da Informação (STI):
          </MainText>
        </Box>

        <MainSolidButton
          text="Abrir Manuais"
          icon={<MenuBookRounded />}
          small
          onClick={() => {
            analyticLog("click_help_wifi_tutorial");
            openLink("https://sti.ufrn.br/manuais");
          }}
        />

        {/* Camisa */}

        <Box mt={5} mb={2} display={"flex"} justifyContent={"start"} alignItems={"center"} gap={1}>
          <HelpRounded />
          <MainText size="subtitle" color="black">
            Camisas da UFRN
          </MainText>
        </Box>

        <Box mb={2}>
          <MainText color="regular">
            As camisas com inscrições só sobre a UFRN vendem no Centro de Convivência que fica em
            frente a Reitoria. Lá dentro do Centro de Convivência você vai procurar uma livraria.
          </MainText>
        </Box>

        <Box mb={2}>
          <MainText color="regular">
            Os próprios alunos se organizam e fazem as suas camisetas também, fazem votação pelo
            design e tal, enfim. Informe-se com seus colegas de curso para saber como pede.
          </MainText>
        </Box>

        <MainSolidButton
          text="Abrir Livraria no Maps"
          icon={<MapRounded />}
          small
          onClick={() => {
            analyticLog("click_help_shirt_location");
            openLink("https://maps.app.goo.gl/1HrtSUxugeSGxZ398");
          }}
        />
      </Box>
    </Box>
  );
}
